import { ReactNode } from 'react';

import { locator } from '../../testing/e2e-locator/locator';
import { Icon } from './Icon';
import { IconProps } from './types/IconProps';

export const UncheckedIcon = (props: IconProps): ReactNode => (
  <Icon {...props} testId={locator.components.icon.unchecked}>
    <rect
      fill="none"
      height="22"
      rx="2"
      stroke="currentColor"
      strokeWidth="1"
      width="22"
      x="1"
      y="1"
    />
  </Icon>
);
